import { HealthContainer } from '@screens/HealthPages/HealthContainer';

export const HealthPage = () => {
  return (
    <div className="dark bg-black h-full w-full" data-testid="health-page">
      <HealthContainer />
    </div>
  );
};
